import axiosClient from './axiosClient';

export const getHeader = (id, errorHandler) => {
    return axiosClient.get(`/feedback/reviews/history/${id}/header/`, { errorHandler });
}

export const getEntries = (id, errorHandler) => {
    return axiosClient.get(`/feedback/reviews/history/${id}/entries/?pageNumber=${0}`, { errorHandler });
}